import {
  ERROR_MESSAGES_DA,
  getCleUserMessage,
  parseCleApiError,
  type ApiErrorBody,
  type CleErrorKind,
} from "@/api/cle-api/errors";
import { useMemo } from "react";

export interface CleApiErrorInfo {
  userMessage: string;
  kind: CleErrorKind | null;
  body: ApiErrorBody | null;
  status: number | null;
  hasError: boolean;
}

export const useCleApiError = (
  error: unknown,
  fallback = ERROR_MESSAGES_DA.INTERNAL_ERROR,
): CleApiErrorInfo =>
  useMemo(() => {
    const cleError = parseCleApiError(error);

    if (!cleError) {
      return {
        userMessage: fallback,
        kind: null,
        body: null,
        status: null,
        hasError: !!error,
      };
    }

    return {
      userMessage: cleError.userMessage,
      kind: cleError.kind,
      body: cleError.body,
      status: cleError.status,
      hasError: true,
    };
  }, [error, fallback]);

export const getCleApiErrorInfo = (
  error: unknown,
  fallback = ERROR_MESSAGES_DA.INTERNAL_ERROR,
): CleApiErrorInfo => {
  const cleError = parseCleApiError(error);

  if (!cleError) {
    return {
      userMessage: error ? getCleUserMessage(error, fallback) : fallback,
      kind: null,
      body: null,
      status: null,
      hasError: !!error,
    };
  }

  return {
    userMessage: cleError.userMessage,
    kind: cleError.kind,
    body: cleError.body,
    status: cleError.status,
    hasError: true,
  };
};
